import router from "next/router";
import React, { useState } from "react";
import Select from "react-select";
import { Row, Label, Col } from "reactstrap";

import { routes } from "@/utils/routes";

type Props = {
  selectedCountry?: { label: string; value: string };
};

const UPSCountrySelect = ({ selectedCountry }: Props) => {
  const [selection, setSelection] = useState(selectedCountry);

  return (
    <Row>
      <Label for="country" xs={12} sm={3}>
        Country:
      </Label>
      <Col xs={12} sm={9}>
        <Select
          classNamePrefix="select"
          isSearchable
          name="country"
          value={selection}
          options={[
            { label: "Canada", value: "ups-canada" },
            { label: "United States", value: "ups-usa" },
          ]}
          isClearable
          onChange={(value: any) => {
            setSelection(value);

            if (value) {
              router.push(`${routes.partners}/${value?.value}`);
            } else {
              router.push(`${routes.partners}/ups`);
            }
          }}
        />
      </Col>
    </Row>
  );
};

export default UPSCountrySelect;
